(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-bestsellers-grid"] && !Shopify.designMode) return;
  try {
    
  // hb-bestsellers : poster image au chargement, puis l'iframe Vimeo est créée pour chaque tuile
  // dès l'arrivée sur la page (lecture auto, muette, vitesse ×1) + enchaînement slot 5.
  (function () {
    var nodes = document.querySelectorAll('[data-hb-bestseller-video]');
    if (!nodes.length) return;

    var vimeoLoading = null;
    function loadVimeoApi() {
      if (window.Vimeo) return Promise.resolve();
      if (vimeoLoading) return vimeoLoading;
      vimeoLoading = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = 'https://player.vimeo.com/api/player.js';
        s.async = true;
        s.onload = resolve;
        document.head.appendChild(s);
      });
      return vimeoLoading;
    }

    function boot(wrap) {
      if (wrap.dataset.hbBooted) return;
      wrap.dataset.hbBooted = '1';
      var src = wrap.getAttribute('data-vimeo-src');
      if (!src) return;
      var ids = (wrap.getAttribute('data-vimeo-ids') || '').split(',').filter(Boolean);
      var chain = wrap.getAttribute('data-chain') === '1';

      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.setAttribute('frameborder', '0');
      iframe.title = wrap.getAttribute('data-title') || '';
      wrap.appendChild(iframe);

      // Masquer le poster de façade une fois la vidéo en place — sinon il reste
      // sous la vidéo et transparaît dans les zones non couvertes ("images derrière").
      var poster = wrap.querySelector('img');
      var hidePoster = function () {
        if (poster) { poster.style.transition = 'opacity .3s ease'; poster.style.opacity = '0'; }
      };
      iframe.addEventListener('load', function () { setTimeout(hidePoster, 500); });

      loadVimeoApi().then(function () {
        if (typeof window.Vimeo === 'undefined' || !ids.length) return;
        try {
          var player = new window.Vimeo.Player(iframe);

          function trySpeed(rates, idx) {
            if (idx >= rates.length) return;
            player.setPlaybackRate(rates[idx]).catch(function () { trySpeed(rates, idx + 1); });
          }

          player.ready().then(function () {
            try { player.setMuted(true); } catch (e) {}
            hidePoster();
            trySpeed([1], 0);
            // Lecture automatique forcée (vitesse normale ×1)
            player.play().catch(function () {});
            // Si le navigateur met la vidéo en pause (autre vidéo, onglet revenu au premier plan…), on relance
            player.on('pause', function () {
              if (document.visibilityState === 'visible') player.play().catch(function () {});
            });
            document.addEventListener('visibilitychange', function () {
              if (document.visibilityState === 'visible') player.play().catch(function () {});
            });

            if (chain && ids.length > 1) {
              var current = 0;
              player.on('ended', function () {
                current = (current + 1) % ids.length;
                player.loadVideo(parseInt(ids[current], 10)).then(function () {
                  try { player.setMuted(true); } catch (e) {}
                  player.play().catch(function () {});
                  trySpeed([1], 0);
                });
              });
            }
          });
        } catch (e) { /* ignore */ }
      });
    }

    // Démarrage automatique dès l'arrivée sur la page d'accueil (les 4 vidéos), sans attendre le défilement
    nodes.forEach(boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-faq"] && !Shopify.designMode) return;
  try {
    
  // Auto-open + scroll to FAQ if URL hash matches
  (function () {
    const open = () => {
      const h = location.hash;
      if (!h.startsWith('#faq-')) return;
      const el = document.querySelector(h);
      if (el && el.tagName === 'DETAILS') {
        el.open = true;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    window.addEventListener('hashchange', open);
    open();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-header"] && !Shopify.designMode) return;
  try {
    
  // Reuse the Dawn `sticky-header` Custom Element which is defined in global.js
  // but add scroll detection for the box-shadow effect
  (function () {
    const header = document.querySelector('.hb-header');
    if (!header) return;

    let lastScroll = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastScroll = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Burger menu
    const burger = header.querySelector('[data-hb-burger]');
    const drawer = header.querySelector('[data-hb-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', () => {
        const open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        burger.setAttribute('aria-label', open ? 'Ouvrir le menu' : 'Fermer le menu');
        drawer.hidden = open;
        document.body.style.overflow = open ? '' : 'hidden';
        // Move focus into drawer when opening, back to burger when closing
        if (!open) {
          const firstLink = drawer.querySelector('a');
          if (firstLink) firstLink.focus({ preventScroll: true });
        } else {
          burger.focus({ preventScroll: true });
        }
      });
      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          burger.click();
        }
      });
      // Close on link click
      drawer.querySelectorAll('a').forEach((a) => {
        a.addEventListener('click', () => {
          burger.setAttribute('aria-expanded', 'false');
          drawer.hidden = true;
          document.body.style.overflow = '';
        });
      });
    }

    // Sync cart badge with Shopify cart updates (PubSub Dawn)
    document.addEventListener('cart:update', (e) => {
      const badge = header.querySelector('[data-cart-count]');
      if (!badge) return;
      const count = e.detail?.cart?.item_count ?? 0;
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-pro-matrix"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.hb-prom');
    if (!root) return;
    const form = root.querySelector('[data-hb-prom-form]');
    const currency = root.dataset.currency || 'EUR';
    const tiers = (root.dataset.tiers || '').split(',').map(function (t) {
      const a = t.split(':'); return { min: parseInt(a[0], 10) || 0, pct: parseFloat(a[1]) || 0 };
    }).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return b.min - a.min; });
    const addBtn = root.querySelector('[data-hb-prom-add]');

    const money = function (cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    };
    const discountFor = function (qty) {
      for (let i = 0; i < tiers.length; i++) { if (qty >= tiers[i].min) return tiers[i].pct; }
      return 0;
    };

    const lines = Array.prototype.slice.call(root.querySelectorAll('[data-hb-line]'));

    const recompute = function () {
      let sub = 0, disc = 0, anyQty = false;
      lines.forEach(function (line) {
        const vEl = line.querySelector('[data-hb-variant]');
        const price = parseInt((vEl.tagName === 'SELECT' ? vEl.options[vEl.selectedIndex].dataset.price : vEl.dataset.price), 10) || 0;
        const num = line.querySelector('[data-hb-num]');
        let qty = parseInt(num.value, 10); if (isNaN(qty) || qty < 0) qty = 0;
        const pct = discountFor(qty);
        const gross = price * qty;
        const net = Math.round(gross * (1 - pct / 100));
        sub += gross; disc += (gross - net);
        if (qty > 0) anyQty = true;
        const totEl = line.querySelector('[data-hb-line-total]');
        const dEl = line.querySelector('[data-hb-line-disc]');
        totEl.textContent = qty > 0 ? money(net) : '—';
        if (pct > 0 && qty > 0) { dEl.hidden = false; dEl.textContent = '−' + pct + '%'; } else { dEl.hidden = true; }
      });
      root.querySelector('[data-hb-subtotal]').textContent = money(sub);
      root.querySelector('[data-hb-discount]').textContent = disc > 0 ? '−' + money(disc) : money(0);
      root.querySelector('[data-hb-grandtotal]').textContent = money(sub - disc);
      if (addBtn) addBtn.disabled = !anyQty;
    };

    lines.forEach(function (line) {
      const range = line.querySelector('[data-hb-range]');
      const num = line.querySelector('[data-hb-num]');
      const variant = line.querySelector('select[data-hb-variant]');
      if (range && num) {
        range.addEventListener('input', function () { num.value = range.value; recompute(); });
        num.addEventListener('input', function () {
          let v = parseInt(num.value, 10); if (isNaN(v) || v < 0) v = 0;
          range.value = Math.min(v, parseInt(range.max, 10));
          recompute();
        });
      }
      if (variant) variant.addEventListener('change', recompute);
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        const items = [];
        lines.forEach(function (line) {
          const vEl = line.querySelector('[data-hb-variant]');
          const id = vEl.tagName === 'SELECT' ? vEl.value : vEl.getAttribute('value');
          let qty = parseInt(line.querySelector('[data-hb-num]').value, 10);
          if (id && qty > 0) items.push({ id: id, quantity: qty });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        const label = addBtn.textContent;
        addBtn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart' : '/cart'; })
          .catch(function () { addBtn.disabled = false; addBtn.textContent = label; });
      });
    }

    recompute();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-product"] && !Shopify.designMode) return;
  try {
    
  // Thumbnail click → swap main image OR mount video iframe / native <video>
  (function () {
    const thumbs = document.querySelectorAll('[data-hb-thumb]');
    const main = document.getElementById('hb-product-main-img');
    const mainWrap = main ? main.parentElement : null;
    const videoSlot = document.getElementById('hb-product-main-video');
    if (!thumbs.length || !main) return;

    const clearVideo = () => {
      if (!videoSlot) return;
      videoSlot.innerHTML = '';
      videoSlot.hidden = true;
      videoSlot.setAttribute('aria-hidden', 'true');
      if (mainWrap) mainWrap.removeAttribute('data-mode');
      main.style.visibility = '';
    };

    const showImage = (src) => {
      clearVideo();
      if (src) main.src = src;
    };

    let vimeoApiPromise = null;
    const loadVimeoApi = () => {
      if (window.Vimeo && window.Vimeo.Player) return Promise.resolve();
      if (vimeoApiPromise) return vimeoApiPromise;
      vimeoApiPromise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://player.vimeo.com/api/player.js';
        s.onload = resolve; s.onerror = reject;
        document.head.appendChild(s);
      });
      return vimeoApiPromise;
    };

    const buildVimeoUI = (iframe, wrap, opts) => {
      opts = opts || {};
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Pictogramme haut-parleur (contour + 3 ondes) — utilisé partout pour le son.
      // waves = nombre d'ondes affichées (0 = son coupé → 3 ondes barrées d'un trait en diagonale).
      const speakerSvg = (waves, cls) =>
        '<svg class="' + (cls || '') + '" viewBox="0 0 32 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
          '<rect x="2" y="8" width="6" height="8" rx="1.5"/>' +
          '<path d="M8 8.5L14.6 3.6c.7-.5 1.6 0 1.6.8v15.2c0 .8-.9 1.3-1.6.8L8 15.5"/>' +
          (waves >= 1 || waves === 0 ? '<path class="hb-vp__wave hb-vp__wave--1" d="M19.5 9.5a3.5 3.5 0 0 1 0 5"/>' : '') +
          (waves >= 2 || waves === 0 ? '<path class="hb-vp__wave hb-vp__wave--2" d="M22.5 7a7 7 0 0 1 0 10"/>' : '') +
          (waves >= 3 || waves === 0 ? '<path class="hb-vp__wave hb-vp__wave--3" d="M25.5 4.5a10.5 10.5 0 0 1 0 15"/>' : '') +
          (waves === 0 ? '<path d="M3 2L29 22" stroke-width="2.4"/>' : '') +
        '</svg>';
      const click = document.createElement('button');
      click.type = 'button'; click.className = 'hb-vp__click'; click.setAttribute('aria-label', 'Lecture / pause');
      const play = document.createElement('span');
      play.className = 'hb-vp__play'; play.setAttribute('aria-hidden', 'true'); play.textContent = '▶';
      const aiBadge = document.createElement('span');
      aiBadge.className = 'hb-vp__ai-badge';
      aiBadge.textContent = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ? 'AI-generated' : 'généré par l\'IA';
      const ctrl = document.createElement('div'); ctrl.className = 'hb-vp__ctrl';
      const vol = document.createElement('div'); vol.className = 'hb-vp__vol';
      const mute = document.createElement('button');
      mute.type = 'button'; mute.className = 'hb-vp__mute'; mute.setAttribute('aria-label', 'Activer le son'); mute.innerHTML = speakerSvg(0, 'hb-vp__mute-icon');
      const vrange = document.createElement('input');
      vrange.type = 'range'; vrange.min = '0'; vrange.max = '100'; vrange.value = '0';
      vrange.className = 'hb-vp__volrange'; vrange.setAttribute('aria-label', 'Volume');
      vol.appendChild(mute); vol.appendChild(vrange);
      const bar = document.createElement('div'); bar.className = 'hb-vp__bar';
      const fill = document.createElement('div'); fill.className = 'hb-vp__fill';
      bar.appendChild(fill);
      const fs = document.createElement('button');
      fs.type = 'button'; fs.className = 'hb-vp__fs';
      fs.setAttribute('aria-label', 'Plein écran'); fs.textContent = '⛶';
      ctrl.appendChild(vol); ctrl.appendChild(bar); ctrl.appendChild(fs);
      const isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      const soundHint = document.createElement('button');
      soundHint.type = 'button'; soundHint.className = 'hb-vp__soundhint'; soundHint.hidden = true;
      soundHint.setAttribute('aria-label', isEn ? 'Turn on sound' : 'Activer le son');
      soundHint.innerHTML =
        '<span class="hb-vp__soundhint-circle">' +
          speakerSvg(3, 'hb-vp__soundhint-icon') +
        '</span>' +
        '<span class="hb-vp__soundhint-text">' +
          '<strong>' + (isEn ? '🎵 This video has music' : '🎵 Vidéo avec musique') + '</strong>' +
          '<span>' + (isEn ? 'Tap here to turn on the sound' : 'Touchez ici pour activer le son') + '</span>' +
        '</span>';
      wrap.appendChild(click); wrap.appendChild(play); wrap.appendChild(aiBadge); wrap.appendChild(ctrl); wrap.appendChild(soundHint);

      if (opts.caption) {
        const cap = document.createElement('div');
        cap.className = 'hb-vp__caption';
        cap.textContent = opts.caption;
        wrap.appendChild(cap);
      }

      // Mode "accéléré x4" : actif à l'arrivée sur la page (sauf reduced-motion).
      // Au premier clic utilisateur, on remet à 0, en x1, et on active le son.
      let isAccelerated = !reducedMotion;
      if (isAccelerated) wrap.classList.add('is-accelerated');

      loadVimeoApi().then(() => {
        const player = new Vimeo.Player(iframe);
        let duration = 0, dragging = false, lastVolume = 0.6, currentVol = 0;
        player.getDuration().then((d) => { duration = d; }).catch(() => {});

        if (isAccelerated) {
          // Lecture à vitesse normale (x1) — l'accélération x8 a été retirée.
          player.setPlaybackRate(1).catch(() => {});
        }

        player.on('timeupdate', (e) => { if (!dragging) fill.style.width = (e.percent * 100) + '%'; if (e.duration) duration = e.duration; });
        player.on('play', () => wrap.classList.remove('is-paused'));
        player.on('pause', () => wrap.classList.add('is-paused'));
        player.on('ended', () => {
          wrap.classList.add('is-paused');
          if (typeof opts.onEnded === 'function') opts.onEnded();
        });

        const switchToNormal = () => {
          isAccelerated = false;
          wrap.classList.remove('is-accelerated');
          player.setPlaybackRate(1).catch(() => {});
          player.setCurrentTime(0).catch(() => {});
          applyVol(lastVolume || 0.6);
          player.play().catch(() => {});
        };

        click.addEventListener('click', () => {
          if (isAccelerated) { switchToNormal(); return; }
          Promise.all([player.getMuted().catch(() => false), player.getPaused()]).then(([m, p]) => {
            if (m || currentVol <= 0) { soundOn(); return; }
            p ? player.play() : player.pause();
          });
        });

        const iconFor = (v) => speakerSvg(v <= 0 ? 0 : (v < 0.5 ? 2 : 3), 'hb-vp__mute-icon');
        const syncVol = (v) => {
          currentVol = v;
          vrange.value = Math.round(v * 100);
          mute.innerHTML = iconFor(v);
          mute.setAttribute('aria-label', v <= 0 ? 'Activer le son' : 'Couper le son');
          if (v > 0) soundHint.hidden = true;
        };
        const applyVol = (v) => {
          v = Math.max(0, Math.min(1, v));
          player.setMuted(v <= 0).catch(() => {});
          player.setVolume(v);
          if (v > 0) lastVolume = v;
          syncVol(v);
        };
        player.getVolume().then(syncVol).catch(() => {});
        player.on('volumechange', (e) => {
          if (!e) return;
          if (e.muted === true) syncVol(0);
          else if (typeof e.volume === 'number') syncVol(e.volume);
        });
        mute.addEventListener('click', (ev) => {
          ev.stopPropagation();
          if (isAccelerated) { switchToNormal(); return; }
          player.getMuted().catch(() => false).then((m) => {
            if (m || currentVol <= 0) soundOn(); else applyVol(0);
          });
        });
        vrange.addEventListener('input', (ev) => { ev.stopPropagation(); applyVol(parseInt(vrange.value, 10) / 100); });
        vrange.addEventListener('pointerdown', (ev) => ev.stopPropagation());
        vrange.addEventListener('click', (ev) => ev.stopPropagation());
        const seekTo = (clientX) => {
          const rect = bar.getBoundingClientRect();
          let pct = (clientX - rect.left) / rect.width;
          pct = Math.max(0, Math.min(1, pct));
          fill.style.width = (pct * 100) + '%';
          if (duration) player.setCurrentTime(pct * duration);
        };
        bar.addEventListener('pointerdown', (ev) => { ev.stopPropagation(); dragging = true; try { bar.setPointerCapture(ev.pointerId); } catch (e) {} seekTo(ev.clientX); });
        bar.addEventListener('pointermove', (ev) => { if (dragging) seekTo(ev.clientX); });
        bar.addEventListener('pointerup', () => { dragging = false; });
        bar.addEventListener('click', (ev) => ev.stopPropagation());

        // Lecture avec le son dès le démarrage. Les navigateurs (surtout Safari / iPhone)
        // peuvent refuser le son tant que le visiteur n'a pas touché la page : dans ce cas
        // on joue en muet, on affiche « Activer le son », et le premier clic / toucher
        // n'importe où sur la page active la musique.
        const soundOn = () => {
          soundHint.hidden = true;
          isAccelerated = false;
          wrap.classList.remove('is-accelerated');
          applyVol(lastVolume || 0.6);
          player.play().catch(() => {});
        };
        soundHint.addEventListener('click', (ev) => { ev.stopPropagation(); soundOn(); });
        const fallbackMuted = () => {
          player.setMuted(true).catch(() => {}).then(() => player.play()).catch(() => {});
          syncVol(0);
          soundHint.hidden = false;
          const evts = ['click', 'keydown', 'touchend'];
          const cleanup = () => evts.forEach((n) => document.removeEventListener(n, onGesture, true));
          const onGesture = (ev) => {
            if (ev.target && wrap.contains(ev.target)) return;
            cleanup();
            if (!soundHint.hidden) soundOn();
          };
          evts.forEach((n) => document.addEventListener(n, onGesture, true));
        };
        player.setMuted(false)
          .then(() => player.setVolume(0.6))
          .then(() => player.play())
          .then(() => Promise.all([player.getVolume(), player.getMuted(), player.getPaused()]))
          .then(([v, m, p]) => {
            if (v > 0 && !m && !p) { isAccelerated = false; wrap.classList.remove('is-accelerated'); syncVol(v); }
            else fallbackMuted();
          })
          .catch(fallbackMuted);

        fs.addEventListener('click', (ev) => {
          ev.stopPropagation();
          // Vimeo API requestFullscreen est plus fiable que document API pour iframe cross-origin.
          if (typeof player.requestFullscreen === 'function') {
            player.requestFullscreen().catch(() => {
              if (iframe.requestFullscreen) iframe.requestFullscreen().catch(() => {});
            });
          } else if (iframe.requestFullscreen) {
            iframe.requestFullscreen().catch(() => {});
          }
        });
      }).catch(() => {});
    };

    const showEmbed = (embedUrl, opts) => {
      if (!videoSlot || !embedUrl) return;
      opts = opts || {};
      const isVimeo = embedUrl.indexOf('player.vimeo.com') > -1;
      const iframe = document.createElement('iframe');
      iframe.src = embedUrl + (embedUrl.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1' + (isVimeo && !opts.userGesture ? '&muted=1' : '');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('frameborder', '0');
      videoSlot.innerHTML = '';
      if (isVimeo) {
        const wrap = document.createElement('div');
        wrap.className = 'hb-vp is-paused';
        wrap.appendChild(iframe);
        videoSlot.appendChild(wrap);
        buildVimeoUI(iframe, wrap, opts);
      } else {
        videoSlot.appendChild(iframe);
      }
      videoSlot.hidden = false;
      videoSlot.setAttribute('aria-hidden', 'false');
      if (mainWrap) mainWrap.setAttribute('data-mode', 'video');
    };

    const showNativeVideo = (src, mime) => {
      if (!videoSlot || !src) return;
      const video = document.createElement('video');
      video.src = src;
      if (mime) video.type = mime;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      videoSlot.innerHTML = '';
      videoSlot.appendChild(video);
      videoSlot.hidden = false;
      videoSlot.setAttribute('aria-hidden', 'false');
      if (mainWrap) mainWrap.setAttribute('data-mode', 'video');
    };

    // Liste ordonnée des thumbs vidéo, pour enchaîner automatiquement la suivante.
    const videoThumbs = Array.from(thumbs).filter((t) => {
      const tp = t.dataset.mediaType || 'image';
      return tp === 'external_video' || tp === 'video';
    });
    const playVideoThumb = (btn, opts) => {
      opts = opts || {};
      thumbs.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const caption = btn.dataset.caption || '';
      const idx = videoThumbs.indexOf(btn);
      const nextVid = idx >= 0 && idx < videoThumbs.length - 1 ? videoThumbs[idx + 1] : null;
      const onEnded = nextVid ? () => playVideoThumb(nextVid) : null;
      const type = btn.dataset.mediaType || 'image';
      const embedOpts = { caption: caption, onEnded: onEnded, userGesture: !!opts.userGesture };
      if (type === 'external_video') {
        showEmbed(btn.dataset.embedUrl, embedOpts);
      } else if (type === 'video') {
        if (btn.dataset.videoSrc) {
          showNativeVideo(btn.dataset.videoSrc, btn.dataset.videoMime);
        } else if (btn.dataset.embedUrl) {
          showEmbed(btn.dataset.embedUrl, embedOpts);
        }
      }
    };

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.dataset.mediaType || 'image';
        if (type === 'external_video' || type === 'video') {
          playVideoThumb(btn, { userGesture: true });
        } else {
          thumbs.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          showImage(btn.dataset.src);
        }
      });
    });

    // Clic sur la grande image alors que la vidéo n'est pas encore lancée → on lance la vidéo avec le son.
    if (videoThumbs.length > 0 && mainWrap) {
      main.style.cursor = 'pointer';
      main.addEventListener('click', () => {
        if (mainWrap.getAttribute('data-mode') === 'video') return;
        const active = Array.from(thumbs).find((t) => t.classList.contains('is-active'));
        if (active && (active.dataset.mediaType || 'image') === 'image' && active !== thumbs[0]) return;
        playVideoThumb(videoThumbs[0], { userGesture: true });
      });
    }

    // Auto-play : à l'arrivée sur la page, si une vidéo existe, on la lance.
    // Sauf si l'utilisateur a demandé moins d'animations (prefers-reduced-motion).
    if (videoThumbs.length > 0) {
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reducedMotion) {
        // Démarre quand la zone vidéo est visible à l'écran (au moins un quart).
        // Délai court pour laisser le LCP de l'image principale se déclencher.
        const startAuto = () => setTimeout(() => playVideoThumb(videoThumbs[0]), 250);
        if ('IntersectionObserver' in window && mainWrap) {
          const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) { io.disconnect(); startAuto(); }
          }, { threshold: 0.25 });
          io.observe(mainWrap);
        } else {
          startAuto();
        }
      }
    }
  })();

  // Flèches carrousel : naviguer entre les photos (images uniquement)
  (function () {
    const allThumbs = Array.from(document.querySelectorAll('[data-hb-thumb]'));
    const imgThumbs = allThumbs.filter((t) => (t.dataset.mediaType || 'image') === 'image');
    const prev = document.querySelector('[data-hb-nav="prev"]');
    const next = document.querySelector('[data-hb-nav="next"]');
    if (!prev && !next) return;
    if (imgThumbs.length <= 1) return; // pas assez de photos → boutons restent masqués
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;

    const go = (dir) => {
      const active = allThumbs.find((t) => t.classList.contains('is-active'));
      let idx = active ? imgThumbs.indexOf(active) : -1;
      if (idx < 0) idx = 0;
      idx = (idx + dir + imgThumbs.length) % imgThumbs.length;
      const target = imgThumbs[idx];
      target.click();
      target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));

    // Navigation clavier ← → quand la galerie a le focus
    const gallery = document.querySelector('.hb-product__gallery');
    if (gallery) {
      gallery.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      });
    }
  })();

  // Sélection de variante → maj id caché, prix, dispo, bouton (fix bug panier)
  (function () {
    const form = document.getElementById('hb-pf');
    if (!form) return;
    const dataEl = document.querySelector('[data-hb-variants]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (variants.length <= 1) return;
    const idInput = form.querySelector('[data-hb-variant-id]');
    const radios = form.querySelectorAll('[data-hb-option]');
    const priceEl = document.querySelector('.hb-product__price');
    const stickyPrice = document.querySelector('[data-hb-sticky-price]');
    const addBtn = form.querySelector('[data-hb-add]');
    const addLabel = form.querySelector('[data-hb-add-label]');
    if (!radios.length) return;

    const money = (cents) => {
      try {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    };

    const selectedOptions = () => {
      const opts = [];
      form.querySelectorAll('fieldset.hb-product__option').forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    };

    const update = () => {
      const chosen = selectedOptions();
      const match = variants.find((v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i]));
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price != null) priceEl.textContent = money(match.price);
      if (stickyPrice && match.price != null) stickyPrice.textContent = money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? (addBtn.dataset.labelAdd || addLabel.textContent) : (addBtn.dataset.labelUnavailable || addLabel.textContent);
      }
    };

    radios.forEach((r) => r.addEventListener('change', update));
    update();
  })();

  // « Payer avec Shopify Payment » : ajoute la variante sélectionnée au panier
  // puis redirige direct sur /checkout (skip page panier).
  (function () {
    const payBtn = document.querySelector('[data-hb-pay-shopify]');
    const form = document.getElementById('hb-pf');
    if (!payBtn || !form) return;
    payBtn.addEventListener('click', async () => {
      if (payBtn.disabled || payBtn.classList.contains('is-loading')) return;
      payBtn.classList.add('is-loading');
      const originalLabel = payBtn.querySelector('.hb-product__paybtn-label');
      const labelText = originalLabel ? originalLabel.textContent : '';
      if (originalLabel) originalLabel.textContent = '…';
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        });
        if (!res.ok) throw new Error('add-to-cart failed');
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'checkout';
      } catch (e) {
        payBtn.classList.remove('is-loading');
        if (originalLabel) originalLabel.textContent = labelText;
        console.error('[hb-pay-shopify]', e);
      }
    });
  })();

  // Barre d'achat sticky mobile : visible quand le CTA principal sort de l'écran
  (function () {
    const bar = document.querySelector('[data-hb-stickybar]');
    const form = document.getElementById('hb-pf');
    if (!bar || !form) return;
    const mainCta = form.querySelector('[data-hb-add]');
    const stickyAdd = bar.querySelector('[data-hb-sticky-add]');
    if (!mainCta) return;

    if (stickyAdd) {
      stickyAdd.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainCta);
        else mainCta.click();
      });
    }

    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { bar.hidden = !(isMobile() && !e.isIntersecting); });
      }, { threshold: 0 });
      io.observe(mainCta);
    } else if (isMobile()) {
      bar.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-hb-stats]');
    if (!root) return;
    const nums = root.querySelectorAll('[data-count]');
    let done = false;
    // a11y : si l'utilisateur a demandé moins d'animations (OS), on saute
    // le count-up et on affiche directement la valeur finale.
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const run = () => {
      if (done) return; done = true;
      nums.forEach((el) => {
        const target = parseInt(el.getAttribute('data-count'), 10) || 0;
        if (reducedMotion) { el.textContent = target; return; }
        const dur = 1300; const start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / dur, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(root);
    } else { run(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
